import { useEffect } from 'react';
import Header from '../../components/dashboard-layout/Header';
import Footer from '../../components/dashboard-layout/Footer';
import { Button } from '../../components/ui/button';
import { Link } from '@tanstack/react-router';
import InitiateBadge from '/badges/initiate.png';
import RookieBadge from '/badges/rookie.png';
import SpecialistBadge from '/badges/specialist.png';
import ProBadge from '/badges/pro.png';
import MasterBadge from '/badges/master.png';
import GrandmasterBadge from '/badges/grandmaster.png';
import LegendBadge from '/badges/legend.png';

const badgeImages = {
    Initiate: InitiateBadge,
    Rookie: RookieBadge,
    Specialist: SpecialistBadge,
    Pro: ProBadge,
    Master: MasterBadge,
    Grandmaster: GrandmasterBadge,
    Legend: LegendBadge,
};

const getDescription = ({ type, totalItems }) => {
    if (type === 'project-quality') {
        return `Got >85% score in ${totalItems} project${totalItems > 1 ? 's' : ''}`;
    }
    if (type === 'quiz-perfectionist') {
        return `Got >90% score in ${totalItems} quiz${totalItems > 1 ? 'zes' : ''}`;
    }
    if (type === 'lesson' || type === 'project' || type === 'quiz') {
        return `Completed ${totalItems} ${type}s`;
    }
    if (type === 'streak-consistency') {
        return `Completed ${totalItems} days in a row`;
    }
    if (type === 'level') {
        return `Reached level ${totalItems}`;
    }
    return `Complete ${totalItems} items`;
};

export default function SharedBadge() {
    const params = new URLSearchParams(window.location.search);
    const name = params.get('name') || 'Someone';
    const title = params.get('title') || 'Badge';
    const badgeLevel = params.get('badgeLevel') || 'Initiate';
    const type = params.get('type') || 'lesson';
    const totalItems = parseInt(params.get('totalItems') || '0', 10);
    const completedItems = parseInt(params.get('completedItems') || '0', 10);

    useEffect(() => {
        document.title = `${name} shared a badge | Zindua LMS`;
    }, [name]);

    const badgeImage = badgeImages[badgeLevel] || badgeImages['Initiate'];

    return (
        <div className="min-h-screen flex flex-col bg-neutral-50">
            <Header />

            <main className="w-112.5 mx-auto grow flex items-center justify-center px-4">
                <div className="flex flex-col items-center justify-center w-full">
                    <div className="border border-neutral-300 rounded-lg  p-8 text-center">
                        <img
                            src={badgeImage}
                            alt={`${title} Badge`}
                            className="w-32 h-32 mx-auto mb-4"
                        />
                        <h1 className="text-2xl font-semibold mb-2">{title}</h1>
                        <p className="text-sm text-neutral-700 mb-4">
                            Shared by <span className="font-medium">{name}</span>
                        </p>
                        <p className="text-neutral-700 mb-6">
                            {getDescription({ type, totalItems })}
                        </p>

                        <div className="flex flex-col justify-center gap-4">
                            <Button variant={'destructive'}>
                                <a
                                    className=""
                                    href={window.location.href}
                                    onClick={e => e.preventDefault()}
                                >
                                    View Link
                                </a>
                            </Button>
                            <Link to="/" preload="intent" preloadDelay={0}>
                                <Button variant={'ghost'} href="/">
                                    Go to Landing Page
                                </Button>
                            </Link>
                        </div>
                        <div className="mt-6 text-sm text-neutral-500">
                            {completedItems}/{totalItems} completed
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
